var _rect, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcWass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white",
    fillOpacity: 0.52
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_16_117",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 7H22.0417V22.0417H7V7Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_16_117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9379 7.11067L15.4867 7.04733C14.1305 6.85152 12.7466 7.04524 11.4963 7.6059C10.246 8.16657 9.18085 9.07109 8.425 10.214C7.62079 11.3065 7.14138 12.6038 7.04194 13.9568C6.9425 15.3097 7.22708 16.6632 7.86292 17.8615C7.92799 17.9816 7.9685 18.1135 7.98209 18.2494C7.99569 18.3853 7.98209 18.5226 7.94208 18.6532C7.6175 19.7694 7.31667 20.8936 7 22.0732L7.39583 21.9544C8.46458 21.6694 9.53333 21.3844 10.6021 21.1232C10.8277 21.0763 11.0621 21.0983 11.275 21.1865C12.2339 21.6545 13.2817 21.9119 14.3483 21.9416C15.4148 21.9712 16.4754 21.7724 17.4588 21.3585C18.4422 20.9445 19.3257 20.325 20.0499 19.5415C20.7742 18.758 21.3225 17.8287 21.658 16.8158C21.9935 15.803 22.1085 14.7301 21.9953 13.6692C21.882 12.6082 21.5431 11.5838 21.0014 10.6646C20.4596 9.74539 19.7275 8.95271 18.8542 8.33975C17.9809 7.72678 16.9865 7.30771 15.9379 7.11067ZM17.9329 17.4973C17.6452 17.7549 17.2943 17.9317 16.9161 18.0096C16.5378 18.0874 16.1457 18.0637 15.7796 17.9407C14.121 17.4729 12.682 16.4322 11.7183 15.0036C11.3503 14.4982 11.0546 13.944 10.8396 13.3569C10.7231 13.0163 10.7021 12.6503 10.7788 12.2986C10.8556 11.947 11.0272 11.623 11.275 11.3619C11.3956 11.2079 11.5599 11.0939 11.7462 11.0346C11.9326 10.9753 12.1326 10.9735 12.32 11.0294C12.4783 11.069 12.5892 11.2986 12.7317 11.4727C12.8478 11.8 12.9824 12.1193 13.1354 12.4307C13.2513 12.5894 13.2997 12.7875 13.2701 12.9819C13.2404 13.1762 13.1351 13.3508 12.9771 13.4677C12.6208 13.7844 12.6762 14.0457 12.9296 14.4019C13.4893 15.209 14.2622 15.8449 15.1621 16.2386C15.4154 16.3494 15.6054 16.3732 15.7717 16.1119C15.8429 16.009 15.9379 15.9219 16.0171 15.8269C16.4763 15.249 16.3338 15.2569 17.0621 15.5736C17.2943 15.6712 17.5186 15.7847 17.735 15.914C17.9487 16.0407 18.2733 16.1752 18.3208 16.3652C18.3665 16.5714 18.3545 16.7861 18.2861 16.9858C18.2176 17.1856 18.0954 17.3626 17.9329 17.4973Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWass);
export default __webpack_public_path__ + "static/media/ic_wass.11cfa06a822c6170cb99efda1e4620fb.svg";
export { ForwardRef as ReactComponent };